module.exports = "mat-dialog-content{width:450px}.do-not-shwo-again-toggle{display:block;margin:20px 0 10px}"